import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SortedCategoryComponent } from './sorted-category.component';

export const ROUTES/*: Routes*/ = [
    { path: 'sorted-category', component: SortedCategoryComponent },
];


@NgModule({
    imports: [
        RouterModule.forChild(ROUTES),
    ],
    declarations: [
        SortedCategoryComponent,
    ],
    exports: [
        SortedCategoryComponent,
    ],
})
export class SortedCategoryModule {}
